import Vec2D from './Vec2d';

export class Particle {
    constructor() {
        this.radius = 2;
        this.color = '#FFF';
        this.lifeSpan = 0;
        this.fric = 0.98;
        this.pos = new Vec2D(0, 0);
        this.vel = new Vec2D(0, 0);
        this.blacklisted = false;
        this.opacity = 1;

        return this;
    }

    update(type, size) {
        this.pos.add(this.vel);
        this.vel.mul(this.fric);
        this.radius -= 0.1;
        this.opacity -= 0.01;

        if (this.radius < 0.3) this.radius = 0.3;

        if (this.lifeSpan-- < 0) {
            this.blacklisted = true;
        }
    }

    reset() {
        this.opacity = 1;
        this.blacklisted = false;
    }
}
